import FilterTextField from '../baseInputTypes/FilterTextField'

type Props = {}
export const Title = (props: Props) => {
  return (
    <FilterTextField label="Title" fieldPath={'advancedTextSearching.title'} />
  )
}
